import { Component, inject } from '@angular/core';
import {
  ButtonComponent,
  ButtonTextDirective,
} from '../../../shared/components/button/button.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { getDefaultLandingPageByRole } from '@orderna/admin-panel/src/utils/get-default-landing-page';
import { LocalStorageService } from '../../../shared/services/local-storage.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule, ButtonComponent, ButtonTextDirective],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css',
})
export class UnauthorizedComponent {
  router = inject(Router);
  localStorage = inject(LocalStorageService);

  async onBackButtonClicked() {
    const accessToken = this.localStorage.getAccessToken();

    if (!accessToken) {
      await this.router.navigateByUrl('/login');
      return;
    }

    const role = this.localStorage.getRole()!;
    const defaultLandingPage = getDefaultLandingPageByRole(role);
    await this.router.navigateByUrl(defaultLandingPage);
  }
}
